import {
  LucideActivity,
  LucideAlarmClock,
  LucideArchive,
  LucideArrowLeft,
  LucideArrowLeftRight,
  LucideArrowRight,
  LucideAward,
  LucideBanknote,
  LucideBanknoteArrowDown,
  LucideBell,
  LucideBox,
  LucideBriefcase,
  LucideBuilding,
  LucideBuilding2,
  LucideCalendar,
  LucideCalendarClock,
  LucideCamera,
  LucideCar,
  LucideChartColumn,
  LucideChartNoAxesColumn,
  LucideChartNoAxesCombined,
  LucideCheck,
  LucideCheckCheck,
  LucideChevronDown,
  LucideChevronLeft,
  LucideChevronRight,
  LucideCircleAlert,
  LucideCircleArrowDown,
  LucideCircleArrowUp,
  LucideCircleCheck,
  LucideCircleCheckBig,
  LucideCircleDashed,
  LucideCirclePause,
  LucideCirclePlus,
  LucideCircleUser,
  LucideCircleX,
  LucideClipboardList,
  LucideClipboardMinus,
  LucideClock,
  LucideCornerUpLeft,
  LucideCreditCard,
  LucideDollarSign,
  LucideDownload,
  LucideEllipsis,
  LucideExternalLink,
  LucideEye,
  LucideEyeOff,
  LucideFileCheck,
  LucideFilePlus,
  LucideFileSearch,
  LucideFileText,
  LucideFlag,
  LucideFolderCheck,
  LucideFolderClosed,
  LucideFolderInput,
  LucideFolderOpen,
  LucideFolderSymlink,
  LucideFunnel,
  LucideFunnelX,
  LucideGavel,
  LucideGift,
  LucideGlobe,
  LucideHandCoins,
  LucideHash,
  LucideHouse,
  LucideImage,
  LucideInfo,
  LucideKeyRound,
  LucideLandmark,
  LucideLayers,
  LucideLayoutDashboard,
  LucideList,
  LucideLoader,
  LucideLoaderCircle,
  LucideLock,
  LucideLogOut,
  LucideMail,
  LucideMap,
  LucideMapPin,
  LucideMenu,
  LucideMoon,
  LucideSun,
  LucideMessageSquare,
  LucideMinus,
  LucideOctagonX,
  LucidePackage,
  LucidePanelLeftClose,
  LucidePanelLeftOpen,
  LucidePaperclip,
  LucidePause,
  LucidePen,
  LucidePenLine,
  LucidePencil,
  LucidePhone,
  LucidePhoneCall,
  LucidePiggyBank,
  LucidePlay,
  LucidePlus,
  LucidePrinter,
  LucideReceipt,
  LucideRefreshCw,
  LucideRotateCcw,
  LucideRotateCcwClock,
  LucideSave,
  LucideScale,
  LucideScrollText,
  LucideSearch,
  LucideSend,
  LucideSettings,
  LucideShield,
  LucideShieldAlert,
  LucideShieldCheck,
  LucideShoppingBag,
  LucideShoppingCart,
  LucideSignature,
  LucideSlidersHorizontal,
  LucideSquare,
  LucideSquareCheckBig,
  LucideSquarePen,
  LucideStore,
  LucideTable,
  LucideTarget,
  LucideThumbsDown,
  LucideThumbsUp,
  LucideToggleLeft,
  LucideToggleRight,
  LucideTrash2,
  LucideTrendingDown,
  LucideTrendingUp,
  LucideTrendingUpDown,
  LucideTriangleAlert,
  LucideTrophy,
  LucideTruck,
  LucideUpload,
  LucideUser,
  LucideUserCheck,
  LucideUserKey,
  LucideUserPlus,
  LucideUsers,
  LucideVault,
  LucideView,
  LucideWallet,
  LucideWalletMinimal,
  LucideWrench,
  LucideX,
  LucideZap,
  LucideZoomIn,
  LucideZoomOut,
  LucideFolderSearch
} from '@lucide/angular';

/**
 * Icônes Lucide enregistrées globalement par `provideLucideIcons()` dans `app.config.ts`.
 *
 * Chaque icône est enregistrée sous son nom lower-kebab-case (`LucidePlus` → `"plus"`)
 * et s'utilise ensuite sans aucun import local :
 *
 * ```html
 * <app-icon name="plus" size="xs" />
 * ```
 *
 * Pour employer une nouvelle icône, l'ajouter à cette liste — sans quoi `<app-icon>`
 * ne rendra rien. La liste reste volontairement limitée aux icônes réellement
 * utilisées : enregistrer les ~1750 icônes de Lucide alourdirait le bundle initial.
 */
export const APP_ICONS = [
  LucideActivity,
  LucideAlarmClock,
  LucideArchive,
  LucideArrowLeft,
  LucideArrowLeftRight,
  LucideArrowRight,
  LucideAward,
  LucideBanknote,
  LucideBanknoteArrowDown,
  LucideBell,
  LucideBox,
  LucideBriefcase,
  LucideBuilding,
  LucideBuilding2,
  LucideCalendar,
  LucideCalendarClock,
  LucideCamera,
  LucideCar,
  LucideChartColumn,
  LucideChartNoAxesColumn,
  LucideChartNoAxesCombined,
  LucideCheck,
  LucideCheckCheck,
  LucideChevronDown,
  LucideChevronLeft,
  LucideChevronRight,
  LucideCircleAlert,
  LucideCircleArrowDown,
  LucideCircleArrowUp,
  LucideCircleCheck,
  LucideCircleCheckBig,
  LucideCircleDashed,
  LucideCirclePause,
  LucideCirclePlus,
  LucideCircleUser,
  LucideCircleX,
  LucideClipboardList,
  LucideClipboardMinus,
  LucideClock,
  LucideCornerUpLeft,
  LucideCreditCard,
  LucideDollarSign,
  LucideDownload,
  LucideEllipsis,
  LucideExternalLink,
  LucideEye,
  LucideEyeOff,
  LucideFileCheck,
  LucideFilePlus,
  LucideFileSearch,
  LucideFileText,
  LucideFlag,
  LucideFolderCheck,
  LucideFolderClosed,
  LucideFolderInput,
  LucideFolderOpen,
  LucideFolderSymlink,
  LucideFunnel,
  LucideFunnelX,
  LucideGavel,
  LucideGift,
  LucideGlobe,
  LucideHandCoins,
  LucideHash,
  LucideHouse,
  LucideImage,
  LucideInfo,
  LucideKeyRound,
  LucideLandmark,
  LucideLayers,
  LucideLayoutDashboard,
  LucideList,
  LucideLoader,
  LucideLoaderCircle,
  LucideLock,
  LucideLogOut,
  LucideMail,
  LucideMap,
  LucideMapPin,
  LucideMenu,
  LucideMoon,
  LucideSun,
  LucideMessageSquare,
  LucideMinus,
  LucideOctagonX,
  LucidePackage,
  LucidePanelLeftClose,
  LucidePanelLeftOpen,
  LucidePaperclip,
  LucidePause,
  LucidePen,
  LucidePenLine,
  LucidePencil,
  LucidePhone,
  LucidePhoneCall,
  LucidePiggyBank,
  LucidePlus,
  LucidePlay,
  LucidePrinter,
  LucideReceipt,
  LucideRefreshCw,
  LucideRotateCcw,
  LucideRotateCcwClock,
  LucideSave,
  LucideScale,
  LucideScrollText,
  LucideSearch,
  LucideSend,
  LucideSettings,
  LucideShield,
  LucideShieldAlert,
  LucideShieldCheck,
  LucideShoppingBag,
  LucideShoppingCart,
  LucideSignature,
  LucideSlidersHorizontal,
  LucideSquare,
  LucideSquareCheckBig,
  LucideSquarePen,
  LucideStore,
  LucideTable,
  LucideTarget,
  LucideThumbsDown,
  LucideThumbsUp,
  LucideToggleLeft,
  LucideToggleRight,
  LucideTrash2,
  LucideTrendingDown,
  LucideTrendingUp,
  LucideTrendingUpDown,
  LucideTriangleAlert,
  LucideTrophy,
  LucideTruck,
  LucideUpload,
  LucideUser,
  LucideUserCheck,
  LucideUserKey,
  LucideUserPlus,
  LucideUsers,
  LucideVault,
  LucideView,
  LucideWallet,
  LucideWalletMinimal,
  LucideWrench,
  LucideX,
  LucideZap,
  LucideZoomIn,
  LucideZoomOut,
  LucideFolderSearch,
];

/**
 * Nom d'icône accepté par `<app-icon>` — dérivé de {@link APP_ICONS}.
 *
 * L'union existe pour que le compilateur refuse un nom inconnu. Sans elle, un nom
 * erroné ne produit aucune erreur : l'icône est simplement absente à l'écran.
 *
 * Régénérer après toute modification d'`APP_ICONS`. Le nom est celui porté par
 * `iconData.name` dans le paquet — ce n'est pas une transformation mécanique du
 * symbole (`LucideHome` s'enregistre sous `"house"`, `LucideEdit3` sous `"pen-line"`).
 */
export type IconName =
  | 'activity' | 'alarm-clock' | 'archive' | 'arrow-left'
  | 'arrow-left-right' | 'arrow-right' | 'award' | 'banknote'
  | 'banknote-arrow-down' | 'bell' | 'box' | 'briefcase'
  | 'building' | 'building-2' | 'calendar' | 'calendar-clock'
  | 'camera' | 'car' | 'chart-column' | 'chart-no-axes-column'
  | 'chart-no-axes-combined' | 'check' | 'check-check' | 'chevron-down'
  | 'chevron-left' | 'chevron-right' | 'circle-alert' | 'circle-arrow-down'
  | 'circle-arrow-up' | 'circle-check' | 'circle-check-big' | 'circle-dashed'
  | 'circle-pause' | 'circle-plus' | 'circle-user' | 'circle-x'
  | 'clipboard-list' | 'clipboard-minus' | 'clock' | 'corner-up-left'
  | 'credit-card' | 'dollar-sign' | 'download' | 'ellipsis'
  | 'external-link' | 'eye' | 'eye-off' | 'file-check'
  | 'file-plus' | 'file-search' | 'file-text' | 'flag'
  | 'folder-check' | 'folder-closed' | 'folder-input' | 'folder-open'
  | 'folder-search'
  | 'folder-symlink' | 'funnel' | 'funnel-x' | 'gavel'
  | 'gift' | 'globe' | 'hand-coins' | 'hash'
  | 'house' | 'image' | 'info' | 'key-round'
  | 'landmark' | 'layers' | 'layout-dashboard' | 'list'
  | 'loader' | 'loader-circle' | 'lock' | 'log-out'
  | 'mail' | 'map' | 'map-pin' | 'menu' | 'moon' | 'sun'
  | 'message-square' | 'minus' | 'octagon-x' | 'package'
  | 'panel-left-close' | 'panel-left-open' | 'paperclip' | 'pause'
  | 'pen' | 'pen-line' | 'pencil' | 'phone'
  | 'phone-call' | 'piggy-bank' | 'plus' | 'play' | 'printer'
  | 'receipt' | 'refresh-cw' | 'rotate-ccw' | 'rotate-ccw-clock'
  | 'save' | 'scale' | 'scroll-text' | 'search'
  | 'send' | 'settings' | 'shield' | 'shield-alert'
  | 'shield-check' | 'shopping-bag' | 'shopping-cart' | 'signature'
  | 'sliders-horizontal' | 'square' | 'square-check-big' | 'square-pen'
  | 'store' | 'table' | 'target' | 'thumbs-down'
  | 'thumbs-up' | 'toggle-left' | 'toggle-right' | 'trash-2'
  | 'trending-down' | 'trending-up' | 'trending-up-down' | 'triangle-alert'
  | 'trophy' | 'truck' | 'upload' | 'user'
  | 'user-check' | 'user-key' | 'user-plus' | 'users'
  | 'vault' | 'view' | 'wallet' | 'wallet-minimal'
  | 'wrench' | 'x' | 'zap' | 'zoom-in'
  | 'zoom-out';
